import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import classNames from 'classnames';
import {HashRouter as Router, Link} from 'react-router-dom';
import RoutesContainer from './RoutesContainer';
import Sidebar from './Sidebar';
import SpinnerRedux from './SpinnerRedux';
import logo from "../../images/FBG-Medier-logo-NEG.PNG";
import TopNavbar from './TopNavbar';
import UserDetails from './users/NavMenuUserDetails';
import SweetAlertModal from './common/SweetAlertModal';
import TokenValidationModal from "./common/TokenValidationModal";
import Toastr from './common/Toastr';
import DemoModeTopbar from './DemoModeTopbar';
import MaintenanceModeChecker from './common/MaintenanceModeChecker';


class MainWrapper extends React.Component {
    constructor(props) {
        super(props);

        this.COLLAPSED_CLASS_NAME = 'collapsed';
        this.EXPANDED_MENU_ICON_CLASS_NAME = 'fa-angle-left';
        this.COLLAPSED_MENU_ICON_CLASS_NAME = 'fa-angle-right';

        this.collapseIfMouseLeave = false;
        this.sidebarExpanded = true;
    }

    toggleMobileMenu(e) {
        this.refs.wrapper.classList.toggle('enlarged');
    }

    toggleMenu(e) {
        if(this.sidebarExpanded) {
            this.collapseSidebar();
            this.collapseIfMouseLeave = true;
        }
        else {
            this.expandSidebar();
            this.collapseIfMouseLeave = false;
        }
    }

    collapseSidebar() {
        this.refs.wrapper.classList.add(this.COLLAPSED_CLASS_NAME);
        this.refs.sidebarCollapseIcon.classList.add(this.COLLAPSED_MENU_ICON_CLASS_NAME);
        this.refs.sidebarCollapseIcon.classList.remove(this.EXPANDED_MENU_ICON_CLASS_NAME);
        this.sidebarExpanded = false;
    }

    expandSidebar() {
        this.refs.wrapper.classList.remove(this.COLLAPSED_CLASS_NAME);
        this.refs.sidebarCollapseIcon.classList.add(this.EXPANDED_MENU_ICON_CLASS_NAME);
        this.refs.sidebarCollapseIcon.classList.remove(this.COLLAPSED_MENU_ICON_CLASS_NAME);
        this.sidebarExpanded = true;
    }

    onMouseEnter() {
        if (this.collapseIfMouseLeave && !this.sidebarExpanded) {
            this.expandSidebar();
        }
    }

    onMouseLeave() {
        if (this.collapseIfMouseLeave && this.sidebarExpanded) {
            this.collapseSidebar();
        }
    }

    render() {
        let {
            user,
            roles
        } = this.props;

        // show spinner if user is not ready
        if(!user.id || !roles.length) {
            return <div id="preloader">
                <div id="status">
                    <div className="spinner" />
                </div>
            </div>;
        }

        return (
            <Router>
                <div id="wrapper" ref="wrapper">
                    <div className="left side-menu">
                        <button type="button" onClick={this.toggleMobileMenu.bind(this)} className="button-menu-mobile button-menu-mobile-topbar open-left waves-effect">
                            <i className="ion-close" />
                        </button>
                        <div className="topbar-left">
                            <div className="text-center">
                                <Link to="/" className="logo"><span className="logo"><img src={logo} alt="FBG Medier"/></span></Link>
                            </div>
                            <UserDetails/>
                        </div>
                        <div className="sidebar-inner slimscrollleft" onMouseLeave={this.onMouseLeave.bind(this)} onMouseEnter={this.onMouseEnter.bind(this)}>
                            <Sidebar/>
                        </div>
                        <div className="collapse-button">
                            <button id="sidebar-collapse" onClick={this.toggleMenu.bind(this)} className="btn btn-default">
                                <i ref="sidebarCollapseIcon" style={{color:'#fff'}} className={classNames('fa', this.EXPANDED_MENU_ICON_CLASS_NAME)}/>
                            </button>
                        </div>
                    </div>
                    <div className="content-page">
                        <div className="content">
                            <DemoModeTopbar/>
                            <div className="topbar">
                                <nav className="navbar-custom">

                                    <ul className="list-inline float-right mb-0 text-right">
                                        <li className="hide-phone list-inline-item notification-list">
                                            <span className="font-16 text-muted align-middle">Logget ind som:</span>
                                        </li>
                                        <li className="list-inline-item align-middle">
                                            <h4 className="hide-phone card-title font-16 mt-0 mb-0"> {user.name} {user.workingTitle ? `[${user.workingTitle}]` : ''}</h4>
                                            <p className="mb-0 logged-header-mobile"> {user.name}<br />{user.workingTitle ? `[${user.workingTitle}]` : ''}</p>
                                        </li>
                                        <TopNavbar/>
                                    </ul>

                                    <ul className="list-inline menu-left mb-0">
                                        <li className="list-inline-item">
                                            <button type="button" onClick={this.toggleMobileMenu.bind(this)} className="button-menu-mobile open-left waves-effect">
                                                <i className="ion-navicon"/>
                                            </button>
                                        </li>
                                        <li className="hide-phone list-inline-item app-search">
                                            <h3 className="page-title"><img src="images/partners.svg" alt="Partners"/></h3>
                                        </li>
                                    </ul>
                                    <div className="clearfix"/>
                                </nav>
                            </div>
                            <div className="page-content-wrapper ">
                                <RoutesContainer/>
                            </div>
                        </div>
                        <SpinnerRedux/>
                        <SweetAlertModal/>
                        <TokenValidationModal/>
                        <footer className="footer">
                            © 2018-nu FBG Medier A/S.
                        </footer>
                    </div>
                    <Toastr/>
                    <MaintenanceModeChecker/>
                </div>
            </Router>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        roles: state.user.roles,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {}
            ), dispatch
        )
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(MainWrapper);


// WEBPACK FOOTER //
// ./web/src/components/MainWrapper.jsx